var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCarPin(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 94,
    height: 95,
    viewBox: "0 0 94 95",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_6659_202704)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M27.1868 40.3115C27.6865 29.2334 37.0398 20.6623 48.071 21.1598C59.1022 21.6574 67.6459 31.0358 67.1462 42.1139C66.8993 47.5872 63.5266 53.3641 59.0334 58.8679C54.853 63.9885 49.839 68.7171 45.8168 72.589C44.1699 70.354 42.2736 68.0163 40.3503 65.6306C38.148 62.8985 35.9037 60.0927 33.8986 57.2415C29.8611 51.5002 26.9408 45.7668 27.1868 40.3115Z",
    fill: "#08A835",
    stroke: "white",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_6659_202704)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M37.8698 39.9575L40.0792 35.9069C40.4332 35.2579 41.1134 34.8541 41.8527 34.8541H51.5755C52.3148 34.8541 52.9951 35.2579 53.3491 35.9069L55.5585 39.9575C55.7203 40.2542 55.8051 40.5868 55.8051 40.9249V48.4906C55.8051 49.6064 54.9007 50.5108 53.7849 50.5108H52.7748C52.1389 50.5108 51.5401 50.2115 51.1586 49.7028L50.8556 49.2987C50.4741 48.79 49.8753 48.4906 49.2394 48.4906H44.1889C43.553 48.4906 42.9542 48.79 42.5727 49.2987L42.2696 49.7028C41.8881 50.2115 41.2893 50.5108 40.6535 50.5108H39.6434C38.5276 50.5108 37.6231 49.6064 37.6231 48.4906V40.9249C37.6231 40.5868 37.7079 40.2542 37.8698 39.9575Z",
    stroke: "white",
    strokeWidth: 1.51517
  }), /*#__PURE__*/React.createElement("path", {
    d: "M36.1085 40.4098C43.1793 42.43 51.2602 42.43 57.3208 40.4098",
    stroke: "white",
    strokeWidth: 1.51517,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M42.6739 34.3486V33.8436C42.6739 32.7278 43.5784 31.8234 44.6941 31.8234H48.7346C49.8503 31.8234 50.7548 32.7278 50.7548 33.8436V34.3486",
    stroke: "white",
    strokeWidth: 1.51517
  }), /*#__PURE__*/React.createElement("path", {
    d: "M50.5929 44.2882H52.0929",
    stroke: "white",
    strokeWidth: 1.51517,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M41.0929 44.2882H42.5929",
    stroke: "white",
    strokeWidth: 1.51517,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M46.5929 34.2882L46.5929 32.2882",
    stroke: "white",
    strokeWidth: 1.51517,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_6659_202704",
    x: 22.172,
    y: 17.1393,
    width: 49.9951,
    height: 61.9668,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 1
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.762378 0 0 0 0 0.766029 0 0 0 0 0.773333 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_6659_202704"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_6659_202704",
    result: "shape"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_6659_202704"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white",
    transform: "translate(34.5929 28.2882)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCarPin);
export default __webpack_public_path__ + "static/media/car-pin.c629772271ccba8ac5cb48699d0dde30.svg";
export { ForwardRef as ReactComponent };